@if (searchQuery) {
  <div class="text-center p-20">
    <span class="text-center">{{ "sphere.searching_for" | translate }}: {{ searchQuery }}&nbsp;&nbsp;&nbsp;</span>
    @if (searching) {
      <fa-icon icon="spinner" [animation]="'spin'" class="m-r-10"></fa-icon>
    }
    <button class="btn btn-secondary btn-sm" (click)="clearSearchQuery.next(true)">Clear</button>
  </div>
}

@if (exchangeService.selectedAttributeFilter) {
  <div class="text-center">
    <span class="text-center">{{ "sphere.showing_that_include" | translate }} {{ exchangeService.selectedAttributeFilter }}&nbsp;&nbsp;&nbsp;</span>
    <button class="small-btn" (click)="exchangeService.selectedAttributeFilter = ''">{{ "sphere.clear" | translate }}</button>
  </div>
}

<div [class.grid-container]="appService.prefersGrid" [class.pad-10]="appService.prefersGrid">
  @for (ware of wares.data; track ware) {
    <myp-exchange-list-item
      tabindex="0"
      (keyup.enter)="exchangeItemTapped($event, ware.id)"
      (click)="exchangeItemTapped($event, ware.id)"
      [class.prod-item]="!appService.prefersGrid"
      [class.item-tile]="appService.prefersGrid"
      [grid]="appService.prefersGrid"
      (updateFavorites)="listUpdateFavorites()"
      [item]="ware"
    ></myp-exchange-list-item>
  }
</div>

<div class="pagination">
  @if (paging) {
    <div class="m-y-10">
      <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
    </div>
  }
  <div #pagingContainer [style.opacity]="paging ? 0 : 1" class="pagination-inner">
    <span class="t-12">{{ wares.data.length }} / {{ wares.total }}</span>
    @if (wares.total > wares.data.length) {
      <button type="button" class="show-more-icon-btn" [attr.aria-label]="'sphere.workspaces.show_more' | translate" (click)="nextPage()">
        <fa-icon icon="chevron-right"></fa-icon>
      </button>
    }
  </div>
</div>
